<template>
  <div>
    <v-row class="row-menu-right mb-3 pl-3 pr-3">
      <!-- <v-btn
        rounded
        color="success"
        dark
        class="mr-2"
        @click="gotocreate"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      Create
      </v-btn> -->
      <!-- <v-btn
        rounded
        color="blue-grey"
        dark
        class="mr-2"
      >
      <v-icon left dark color="white">mdi-cloud-upload</v-icon>
      Import
      </v-btn>
      <v-btn
        rounded
        color="#2196F3"
        dark
      >
      <v-icon left dark color="white" small>fa-file-export</v-icon>
      Export
      </v-btn> -->
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="lineworkData"
        class="border-table-employee"
        item-key="_id"
        :loading="loading"
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
        :page.sync="page"
        :items-per-page="perPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                dark
                icon
                class="mt-3 mb-3"
                @click="gotoEdit(item)"
              >
              <v-icon color="#2BA197" small>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">จัดการตำแหน่งงาน</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="mt-3 mb-3 ml-2"
                @click="checkDelPosition(item._id)"
              >
              <v-icon color="error" small>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">ลบตำแหน่งงาน</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-row>
      <v-col cols="12" class="pa-0">
      <div class="justify-end d-flex align-end pt-4">
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination>
      </div>
      </v-col>
    </v-row>
    </div>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
        app
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
    <v-dialog v-model="dialogConfirmDel" max-width="400px">
      <v-card height="180px" style="border-radius: 12px;">
        <v-card-title class="button-color-outline ra-head-text-bold justify-center pa-5" style="font-size: 18px">ต้องการลบข้อมูลนี้ใช่หรือไม่</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center" style="font-size: 16px">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline pl-5 pr-5 mr-3" style="border-radius: 6px;" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="button-color pl-5 pr-5" style="border-radius: 6px;" dark @click="deletePositionData()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DialogEditPosition/>
  </div>
</template>

<script>
import {
  // getSelectPosition,
  getPositionList,
  deletePosition
} from '@/API/API'
// import { OverlayLoading } from '@/components/index'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import DialogEditPosition from '../_update/dialogEditPosition'
import { EventBus } from '@/EventBus'
import FileSaver from 'file-saver'
import swal from 'sweetalert'

export default {
  components: {
    OverlayLoading,
    DialogEditPosition
  },
  data () {
    return {
      multiLine: true,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      expanded: [],
      keywordShortName: [],
      keywordCompanyName: [],
      keywordGroupCompanyName: [],
      keywordPositionLevel: [],
      loading: true,
      total: -1,
      perPage: 15,
      pageCount: 0,
      page: 1,
      canSave: false,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          width: '70px',
          sortable: false
        },
        { text: 'ชื่อตำแหน่ง', value: 'positionName' },
        { text: 'ระดับตำแหน่งพนักงาน', value: 'positionLevel' },
        { text: 'ชื่อบริษัท', value: 'companyName' },
        // { text: 'ชื่อเครือ', value: 'groupCompanyName' },
        { text: 'จัดการ', value: 'actions', width: '115px', sortable: false, align: 'center fixed', class: 'column-fix' },
        { text: '', value: 'data-table-expand' }
      ],
      mockup: [],
      selectData: [],
      lineworkData: [],
      positionId: '',
      dialogConfirmDel: false
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  beforeDestroy () {
    EventBus.$off('filterPosition')
    EventBus.$off('closedialogEditPosition')
    EventBus.$off('closedialogCheckFile')
    EventBus.$off('downloadFile')
  },
  mounted () {
    EventBus.$on('filterPosition', this.getSelect)
    EventBus.$on('closedialogEditPosition', this.closeDialogPosition)
    EventBus.$on('closedialogUploadFile', this.initData)
    EventBus.$on('downloadFile', this.dowloadFile)
  },
  methods: {
    getSelect (data) {
      this.keywordShortName = data.positionName
      this.keywordCompanyName = data.companyName
      this.keywordGroupCompanyName = data.groupCompany
      this.keywordPositionLevel = data.positionLevelId
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTable()
    },
    closeDialogPosition (item, type) {
      // this.loading = true
      if (type === 'edit') {
        this.text = 'คุณได้ทำการแก้ไข้อมูลเรียบร้อยแล้ว'
        this.snackbarColor = 'success'
        this.snackbar = true
        this.initDataTable()
      } else if (type === 'delete') {
        this.delPosition(item)
        this.loading = true
      }
    },
    initData () {
      // this.initSelectData()
      this.initDataTable()
    },
    // async initSelectData () {
    //   this.loading = true
    //   this.selectData = []
    //   const token = this.tokenUser
    //   try {
    //     const res = await getSelectPosition(token)
    //     if (res.success) {
    //       if (res.result.length) {
    //         this.selectData = res.result[0]
    //         // EventBus.$emit('getFilterPosition', this.selectData)
    //         // EventBus.$emit('selectPosition', res.result[0])
    //       }
    //       // console.log(res)
    //     } else {
    //       // console.log(res)
    //     }
    //   } catch (error) {
    //     // alert(error)
    //     console.log(error)
    //   } finally {
    //     this.loading = false
    //   }
    // },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    async initDataTable () {
      this.loading = true
      this.lineworkData = []
      const temp = []
      var obj = {
        positionName: [this.keywordShortName],
        companyId: [this.keywordCompanyName],
        groupCompanyId: [this.keywordGroupCompanyName],
        positionLevelId: [this.keywordPositionLevel],
        // mngHeaderName: this.keywordUserName,
        // mngHeaderPosition: this.keywordUserPosition,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getPositionList(obj, this.tokenUser)
        // console.log('res', res)
        if (res.success) {
          if (res.result.length) {
            var filterValue = res.result.filter(r => {
              if (r.orgChartHeaderName === null) {
                // console.log('null')
                return r
              }
            })
            this.isLoading = false
            this.value = filterValue.map((orgchart, index) => {
              orgchart.orgChartHeaderName = '-'
              return orgchart
            })
            res.result.map((el, index) => {
              temp.push({
                no: ((this.page - 1) * this.perPage) + index + 1,
                ...el
              })
            })
          }
          this.total = res?.count || -1
          this.lineworkData = temp
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async dowloadFile () {
      var obj = {
        positionName: [this.keywordShortName],
        companyId: [this.keywordCompanyName],
        groupCompanyId: [this.keywordGroupCompanyName],
        positionLevelId: [this.keywordPositionLevel],
        // mngHeaderName: this.keywordUserName,
        // mngHeaderPosition: this.keywordUserPosition,
        limit: this.perPage,
        page: this.page
      }
      await this.axios({
        method: 'post',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/position/download/position`,
        headers: {
          authorization: this.tokenUser
        },
        data: obj
        // url: `${this.api}/uploads/companyFile/fileposition.xlsx`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'ไฟล์ข้อมูลตำแหน่งงาน.xlsx')
      }).catch(e => {
        console.log(e)
      })
    },
    checkDelPosition (id) {
      this.positionId = id
      this.dialogConfirmDel = true
    },
    async deletePositionData () {
      const obj = {
        positionId: this.positionId
      }
      try {
        const res = await deletePosition(obj, this.tokenUser)
        if (res.success) {
          // this.text = 'คุณได้ทำการร้องขอลบธุรกิจเรียบร้อยแล้ว'
          // this.snackbarColor = 'success'
          // this.snackbar = true
          swal('สำเร็จ', 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว', 'success', {
            button: false,
            timer: 2000
          })
          this.dialogConfirmDel = false
          this.initDataTable()
          this.loading = false
        } else {
          this.dialogConfirmDel = false
          swal('ผิดพลาด', 'ไม่สามารถลบข้อได้ กรุณาลองใหม่', 'error', {
            button: false,
            timer: 2000
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    gotocreate () {
      this.$router.push('manageposition/create')
    },
    gotoEdit (data) {
      EventBus.$emit('opendialogEditPosition', data)
      // this.$router.push('manageposition/update')
      // this.$router.push({
      //   name: 'managePositionUpdate',
      //   params: {
      //     item: data,
      //     id: data._id
      //   }
      // })
    }
  }
}
</script>

<style>
/* table */
.theme--light.v-pagination .v-pagination__item--active {
    background: #2BA197 !important;
    color: #FFFFFF;
}
.v-pagination__item {
    background: transparent;
    border-radius: 4px;
    font-size: 14px;
    height: 30px;
    margin: 0.3rem;
    min-width: 30px;
    padding: 0 5px;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0, 0, 0.2, 1);
    width: auto;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}
.v-pagination__navigation {
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    height: 30px;
    width: 30px;
    margin: 0.3rem 10px;
}
/* end */
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
.btn-edit-dep {
  background-color: #0370B7 !important;
  color: #fff !important;
}
.btn-del-dep {
  background-color: #da2525 !important;
  color: #fff !important;
}
</style>
